import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate, registerEnabled } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import auth from './routes/auth'
import students from './routes/students'
import group from './routes/groups'
import rol from './routes/roles'
import setting from './routes/settings'
import user from './routes/users'
import privacy from './routes/privacy'
import enrollments from './routes/enrollments'
import invoices from './routes/invoices'
import expenses from './routes/expenses'
import sections from './routes/sections'
import lessons from './routes/lessons'
import courses from './routes/courses'
import teachers from './routes/teachers'
import taxes from './routes/taxes'
import products from './routes/products'
import families from './routes/families'
import classrooms from './routes/classrooms'
import calendar from './routes/calendar'
import cash from './routes/cash'
import cash_movements from './routes/cash_movements'
import discounts from './routes/discounts'
import providers from './routes/providers'
import accounts from './routes/accounts'
import { existsModule } from '@/hooks/modulesUtils'
import axios from '@axios'
import crm from './routes/crm'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ('@/views/pages/Home.vue'),
            meta: {
                pageTitle: 'Home',
                breadcrumb: [{
                    text: 'Home',
                    active: true,
                }, ],
                resource: 'home',
            },
        },
        {
            path: '/profile',
            name: 'profile',
            component: () =>
                import ('@/views/pages/Profile.vue'),
            meta: {
                pageTitle: 'Profile',
                breadcrumb: [{
                    text: 'Profile',
                    active: true
                }],
                resource: 'profile'
            },
        },
        {
            path: '/cash-selector',
            name: 'cash-selector',
            component: () =>
                import ('@/views/pages/tpv/CashSelector.vue'),
            meta: {
                pageTitle: 'TPV',
                breadcrumb: [
                    {
                        text: 'TPV',
                        active: true
                    }
                ],
                resource: 'tpv'
            }
        },
        {
            path: '/tpv',
            name: 'tpv',
            component: () =>
                import ('@/views/pages/tpv/TPV.vue'),
            meta: {
                pageTitle: 'TPV',
                breadcrumb: [
                    {
                        text: 'TPV',
                        active: true
                    }
                ],
                resource: 'tpv'
            }
        },
        {
            path: '/checkout',
            name: 'checkout',
            component: () =>
                import ('@/views/pages/checkout/checkout.vue'),
            meta: {
                pageTitle: 'Checkout',
                breadcrumb: [
                    {
                        text: 'Checkout',
                        active: true
                    }
                ],
                resource: 'tpv'
            }
        },
        {
            path: '/order-resume/:id',
            name: 'order-resume',
            component: () => 
                import ('@/views/pages/checkout/OrderResume.vue'),
            meta: {
                pageTitle: 'Order resume',
                breadcrumb: [
                    {
                        text: 'Order resume',
                        active: true
                    },
                ],
                resource: 'tpv'
            }
        },
        {
            path: '/correct/:id',
            name: 'correct-invoice',
            component: () => 
                import ('@/views/pages/invoices/InvoicesCorrect.vue'),
            meta: {
                pageTitle: 'Correct invoice',
                breadcrumb: [
                    {
                        text: 'Correct invoice',
                        active: true
                    },
                ],
                resource: 'invoice',
                action: 'read'
            }
        },
        ...auth,
        ...calendar,
        ...students,
        // ...group,
        ...rol,
        ...setting,
        ...user,
        ...privacy,
        ...enrollments,
        ...invoices,
        ...expenses,
        ...sections,
        ...courses,
        ...taxes,
        ...products,
        ...families,
        ...cash,
        ...cash_movements,
        // ...discounts,
        ...providers,
        ...accounts,
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

if (existsModule('Academy')) router.addRoutes([...teachers])
if (existsModule('Academy')) router.addRoutes([...classrooms])
if (existsModule('Academy')) router.addRoutes([...lessons])
// if (existsModule('CRM')) router.addRoutes([...crm])

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn()
    
    if (!canNavigate(to)) {

        if (!isLoggedIn) return next({ name: 'login' })
        return next({ name: 'not-authorized' })
    }

    // Settings > enable public register
    if (to.name == "register") {
        registerEnabled().then(function(result) {
            let registro = false
            result.data == "true" ? registro = true : registro = false
            if (!registro) {
                return next({ name: 'not-authorized' })
            }
        });
    }

    /**
     * Comprobar que la caja esta abierta mientras se utiliza el tpv
     */
    if(to.name == 'tpv' || to.name == "checkout"){
        let cash = JSON.parse(localStorage.getItem('cashSelected'));
        if(cash){
            axios.get(`cashes/${cash.id}`).then(response => {
                if(!response.data.cash.status){
                    return next({ name: 'cash-selector' })
                }
            })
        }else{
            return next({ name: 'cash-selector' })
        }
    }

    /**
     * Comprobar que haya algún producto en el carrito antes de poder acceder al checkout
     */
     if(to.name == "checkout"){
        let shoppingBasket = JSON.parse(localStorage.getItem('shoppingBasket'));
        if(shoppingBasket){
            if (shoppingBasket.length==0) {
                return next({ name: 'tpv' })
            }
        }else{
            return next({ name: 'tpv' })
        }
    }

    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        return next({ name: 'home' })
    }

    return next()
})


router.afterEach(() => {
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router
